import { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PageHero from "@/components/PageHero";
import FinalCTA from "@/components/FinalCTA";
import GuideCard from "@/components/GuideCard";
import { FadeUp } from "@/components/Reveal";
import { SEO } from "@/lib/seo";
import { api } from "@/lib/api";

const CATEGORIES = ["All", "Universities", "Applications", "Scholarships", "Student Life", "Visa & Preparation", "Living in Australia"];

export default function Guides() {
  const [guides, setGuides] = useState([]);
  const [category, setCategory] = useState("All");

  useEffect(() => {
    const params = category === "All" ? {} : { category };
    api.get("/guides", { params }).then((r) => setGuides(r.data)).catch(() => {});
  }, [category]);

  return (
    <div data-testid="guides-page">
      <SEO title="Guides — Studying in Australia | Vitaliah" description="Practical guides on Australian universities, applications, scholarships, visas, student life and living in Australia for international students." />
      <Navbar />
      <PageHero
        overline="Guides"
        title="Understand studying in Australia."
        subtitle="Clear, honest guides written for international students and their families — no jargon, no sales pitch."
      />
      <section className="py-20">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <FadeUp>
            <div className="flex flex-wrap gap-3" data-testid="guide-categories">
              {CATEGORIES.map((c) => (
                <button
                  key={c}
                  data-testid={`guide-cat-${c.toLowerCase().replace(/\W+/g, "-")}`}
                  onClick={() => setCategory(c)}
                  className={`px-6 py-2.5 text-sm font-medium border transition-colors duration-300 ${
                    category === c ? "bg-navy text-cream border-navy" : "border-border text-navy/70 hover:border-gold hover:text-gold"
                  }`}
                >
                  {c}
                </button>
              ))}
            </div>
          </FadeUp>
          <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="guides-grid">
            {guides.map((g, i) => <GuideCard key={g.id || g.slug} g={g} index={i} />)}
          </div>
          {guides.length === 0 && (
            <p data-testid="guides-empty" className="mt-20 text-center text-navy/50">No guides in this category yet — new articles are published regularly.</p>
          )}
        </div>
      </section>
      <FinalCTA />
      <Footer />
    </div>
  );
}
